export default "__VITE_ASSET__BpXxotL2__"